export default {
  helpText: 'Vyberte a usporiadajte stĺpce, ktoré sa majú zobraziť v tabuľke prehľadu dielov. Toto nastavenie platí globálne pre všetkých používateľov.',
  selectedColumns: 'Vybrané stĺpce',
  nonSelectedColumns: 'Dostupné stĺpce',
};
